// JavaScript code to reveal sections on scroll

const revealSections = document.querySelectorAll('.reveal-section');

const revealObserverOptions = {
  root: null, 
  threshold: 0.2, 
};

const revealObserver = new IntersectionObserver((entries, revealObserver) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, revealObserverOptions);

revealSections.forEach(section => {
  revealObserver.observe(section);
});